import { Text, VStack } from "@gluestack-ui/themed";
import { Icon } from "@repo/core/components/core/Icon";
import { Pressable } from "@gluestack-ui/themed";
import { memo, useCallback } from "react";
import Spinner from "@repo/core/components/core/Spinner";

import { ProposalOptionsItemProps } from "./types";
import { PressableProps } from "@repo/core/components/core/Shortcuts/types";

export const ProposalOptionsItem = memo(({
  icon,
  label,
  iconColor,
  iconColorHover,
  action,
  onPress,
  isLoading = false,
  isDisabled = false
}: ProposalOptionsItemProps) => {
  const handlePress = useCallback(() => {
    if (isDisabled || isLoading) {
      return;
    }
    onPress(action);
  }, [action, isDisabled, isLoading, onPress]);

  return (
    <Pressable
      flexDirection="row"
      p="$3"
      alignItems="center"
      $hover-backgroundColor="$secondary50"
      $pressed-backgroundColor="$secondary50"
      gap="$2"
      onPress={handlePress}
      disabled={isDisabled || isLoading}
      opacity={isDisabled ? 0.5 : 1}
    >
      {({ hovered, pressed }: PressableProps) => {
        const active = !isDisabled && (hovered || pressed);
        const color =
          (iconColor && (active ? iconColorHover : iconColor)) ||
          (active ? "$primary700" : "$textLight800");
        return (
          <>
            <VStack>
              <Icon name={icon} variant="solid" size={24} color={color} />
            </VStack>
            <VStack flex={1}>
              <Text fontSize="$md" fontWeight={600} color={color}>
                {label}
              </Text>
            </VStack>

            <VStack>
              {isLoading ? (
                <Spinner size="small" color="$primary700" />
              ) : (
                <Icon
                  name="chevron-right"
                  size={24}
                  color={active ? "$primary700" : "$textLight800"}
                />
              )}
            </VStack>
          </>
        );
      }}
    </Pressable>
  );
});
